import * as React from 'react';
import { useEffect, useState } from 'react';
import useFetch from 'use-http';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import WorkersCompRate from 'src/models/personnel/WorkersCompRate';
import { ODataOptions } from 'src/util/ODataBuilder';

interface ICheckRegisterWorkersCompDialogProps {
    dialogName: string;
    hideDialog: () => void;
}

const formatDate = (value: Date | string): string => {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString();
};

// Mirrors the Workers_Comp block (opened by the main screen's "Worker's Comp" button) - a grid of
// worker's comp percentage rates by state, code, and effective date, sourced from the `workers_comp`
// table (state = '%' means ALL States, matching Check_WC_Percent's own ltrim/rtrim/LIKE lookup).
const CheckRegisterWorkersCompDialog = (props: ICheckRegisterWorkersCompDialogProps) => {
    const { get, response } = useFetch();
    const [rows, setRows] = useState<Array<WorkersCompRate>>([]);

    useEffect(() => {
        const fetchWorkersComp = async () => {
            const options = new ODataOptions().addSkipTop(0, 50);
            const result = await get(`/v1.0/Payroll/workerscomp${options.toString()}`);
            if (response.ok) {
                setRows(result?.items ?? []);
            }
        };
        fetchWorkersComp();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog title="Worker's Comp" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '40%' }}>
            <div style={{ maxHeight: '25rem', overflowY: 'auto' }}>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>State (% = ALL States)</th>
                            <th>Percentage</th>
                            <th>Code</th>
                            <th>Effective Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>{row.state}</td>
                                <td style={{ textAlign: 'right' }}>{row.pct}</td>
                                <td>{row.code}</td>
                                <td>{formatDate(row.effDate)}</td>
                            </tr>
                        ))}
                        {rows.length === 0 && (
                            <tr><td colSpan={4} className="bold-centered">No Worker's Comp Rates</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '20%', marginRight: '1rem' }} text="OK" onClick={() => props.hideDialog()} />
                <Button className="blue-hover-button" style={{ width: '20%' }} text="Cancel" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default CheckRegisterWorkersCompDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/checkRegister/CheckRegisterWorkersCompDialog.tsx